import { QueryClient } from "@tanstack/react-query"
import { getGetFilteredRemindersPagedQueryKey } from "@/orval/gen"

import { getCountOverdueRemindersForCurrentUserQueryKey } from "@/orval/gen/api/reminder/reminder"

export function invalidateReminderQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    queryKey: getGetFilteredRemindersPagedQueryKey(),
  })
  queryClient.invalidateQueries({
    queryKey: ["/api/Reminder/HasOwnOpenReminders"],
  })
  queryClient.invalidateQueries({
    queryKey: ["/api/Reminder/HasOverdueReminderForCurrentUser"],
  })
  queryClient.invalidateQueries({
    queryKey: getCountOverdueRemindersForCurrentUserQueryKey(),
  })
}
